import { Box, Flex } from "@chakra-ui/react";
import React from "react";
import { InfoToolTip } from "../../../../atoms/InfoToolTip";
import { TransactionsNeedsReviewList } from "../../mainTransactionTable/TransactionsNeedsReviewList";
import {
  SectionContainer,
  SectionTitle,
  TransactionOverviewPaddingX,
} from "./SectionTitle";

export const TransactionSuggestionsSection = React.memo(
  function TransactionSuggestionsSection({
    needsReviewItems,
  }: {
    needsReviewItems: React.ReactElement[];
  }): React.ReactElement | null {
    if (needsReviewItems.length === 0) {
      return null;
    }

    return (
      <Box>
        <SectionContainer>
          <SectionTitle>Syla Suggestions</SectionTitle>
          <InfoToolTip
            label="Syla automatically identifies recommendations for each transaction. By following these suggestions you can improve your tax outcomes and minimise risk."
            wrap
          />
        </SectionContainer>

        <Box px={TransactionOverviewPaddingX}>
          <Flex
            borderColor="warning.300"
            borderWidth="1px"
            borderRadius="md"
            bgColor="warning.25"
            p={2}
          >
            <TransactionsNeedsReviewList items={needsReviewItems} />
          </Flex>
        </Box>
      </Box>
    );
  },
);
